module.exports = __webpack_public_path__ + "static/media/any.8ea0d6aa.png";